import { Fab, Tooltip } from "@mui/material";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";

export const GenerateRecipeButton = ({
  onClick,
  size = "small",
  color = "primary",
  disabled = false,
}) => {
  return (
    <Tooltip title="Generar receta">
      <Fab 
        onClick={onClick} 
        color={color} 
        size={size}
        disabled={disabled}
      >
        <PostAddOutlinedIcon />
      </Fab>
    </Tooltip>
  );
};
